import React from "react";
import {observer} from "mobx-react";
import {useViewController} from "data/services/locator";
import {Bindings} from "data/constants/bindings";
import {type IModalSecondaryRegistrationController} from "views/components/modals/modal_secondary_registration/modal_secondary_registration.controller";
import {Box, FormControl, Modal, Stack, Typography} from "@mui/material";
import {Checkbox, ErrorText, Input, Label} from "views/components/form";
import {Exist} from "views/components/exist/exist.component";
import {ButtonPrimary} from "views/components/buttons/buttons.component";
import styled from "@emotion/styled";
import {some} from "lodash";
import {ReactComponent as MlbLogo} from "assets/img/mlb-potg-logo.svg";

const ModalContent = styled.div`
	position: fixed;
	top: 50%;
	left: 50%;
	transform: translate(-50%, -50%);
	display: flex;
	flex-direction: column;
	justify-content: flex-start;
	align-items: center;
	gap: 12px;
	outline: none;
	max-width: 600px;
	width: 100%;
	background: #fff;
	padding: 40px 20px;
	border-radius: 24px;
	text-align: center;
	color: #070a0d;
	font-family: var(--fontFamilyBase);

	@media screen and (max-width: 640px) {
		max-width: unset;
		left: 24px;
		right: 24px;
		width: auto;
		transform: translateY(-50%);
	}

	button {
		max-width: 300px;
	}
`;

const Form = styled("form")`
	width: 100%;
	margin: 20px auto 20px;

	.MuiFilledInput-root {
		//background: #2c2c2e;

		&:focus {
			&:before {
				border-bottom: 1px solid #aeaeb2;
			}
		}
		&:before {
			border-bottom: 1px solid #aeaeb2;
		}
	}

	label {
		display: flex;
		align-items: center;
	}

	input {
		color: #090b0f !important;
	}
`;

const ButtonRow = styled(Box)`
	display: flex;
	justify-content: center;
	align-items: center;
	flex-direction: column;
	gap: 12px;
	width: 100%;
	padding: 24px 0 6px;
`;
const ImageContainer = styled(Box)`
	width: 100%;
	display: flex;
	justify-content: center;
	align-items: center;
	padding: 12px 0;
`;

export const ModalSecondaryRegistration: React.FC = observer(() => {
	const {
		i18n,
		isOpen,
		// username,
		mlbUserName,
		error,
		isFormDisabled,
		isFormDisabledByData,
		handleInputUserNameValue,
		handleCheckboxChange,
		handleFormSubmit,
		handleFormOnChange,
	} = useViewController<IModalSecondaryRegistrationController>(
		Bindings.ModalSecondaryRegistrationController
	);

	return (
		<Modal open={isOpen}>
			<ModalContent>
				<ImageContainer>
					<MlbLogo />
				</ImageContainer>
				<Typography textAlign="center" variant="h5">
					{i18n.t("modal.registration.title", "Complete Registrations")}
				</Typography>
				<Form onSubmit={handleFormSubmit} onChange={handleFormOnChange}>
					<Stack direction="column" gap={2.5}>
						<FormControl fullWidth>
							<Input
								defaultValue={mlbUserName}
								// value={mlbUserName}
								onInput={handleInputUserNameValue}
								variant={"filled"}
								label={i18n.t("modal.registration.user_name", "User name")}
								name="username"
								type="text"
								placeholder={i18n.t("modal.registration.user_name", "User name")}
								inputProps={{maxLength: 25}}
								required={true}
								error={Boolean(error?.username)}
								helperText={error?.username}
							/>
						</FormControl>
						<Stack direction="row" gap={2}>
							<Checkbox
								disabled={isFormDisabled}
								name="terms"
								id="terms"
								onChange={handleCheckboxChange}
								required={true}
							/>
							<Label htmlFor="terms">
								{i18n.t("modal.registration.terms", "Accept Terms & Conditions")}
								{"*"}
							</Label>
						</Stack>
						<Exist when={error?.terms}>
							<ErrorText>{error?.terms}</ErrorText>
						</Exist>
					</Stack>
					<ButtonRow>
						<ButtonPrimary
							fullWidth
							variant="contained"
							type="submit"
							size="large"
							disabled={some([isFormDisabled, isFormDisabledByData])}>
							{i18n.t("modal.confirm.confirm", "Confirm")}
						</ButtonPrimary>
					</ButtonRow>
				</Form>
			</ModalContent>
		</Modal>
	);
});
